import { CollectionHighlightsSnakeCase } from '../types';

const convertHighlightsItem = (data: CollectionHighlightsSnakeCase[]) => {
  return data.map((item) => {
    return {
      dateCreated: item.date_created,
      hasContentsDeleted: item.has_contents_deleted,
      ...item,
    };
  });
};

export default convertHighlightsItem;
